export const OPEN_SNACKBAR = "app/Snackbar/OPEN_SNACKBAR";
export const CLOSE_SNACKBAR = "app/Snackbar/CLOSE_SNACKBAR";

export const openSnackbar = (message, variant = "error") => ({
  type: OPEN_SNACKBAR,
  message,
  variant,
});

export const closeSnackbar = () => ({
  type: CLOSE_SNACKBAR,
});
